import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.667 1.333H5.333a2 2 0 0 0-2 2V14a.667.667 0 0 0 1 .58L8 12.46l3.667 2.12a.67.67 0 0 0 .333.087.667.667 0 0 0 .667-.667V3.333a2 2 0 0 0-2-2m.666 11.514-3-1.734a.67.67 0 0 0-.666 0l-3 1.734V3.333a.667.667 0 0 1 .666-.666h5.334a.667.667 0 0 1 .666.666z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })